export default "__VITE_ASSET__CjAjSy6___"